import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { container } from '@intigral/domain/lib/DataDomain';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { DI } from '@intigral/constant/config/DIContainer';
export default function useProfileAvatars() {
    const response = useQuery({
        queryKey: ['profile_avatars'],
        queryFn: async () => {
            try {
                const commonService = container.resolve<ICustomConfigurationService>(
                    DI.SERVICES.ICustomConfigurationService
                );
                const response = await commonService.getProfileAvatars();
                return response?.profileAvatars || [];
            } catch (e) {
                return [];
            }
        },
        staleTime: 60 * 60 * 1000,
    });

    return response;
}
